// import $ from 'jquery';

jQuery(function () {
  console.log("worldmap Ready");

  const theMap = $("#worldmap");
  const tip = $(".map-tooltip");
  const overlay = $("#map-overlay");
  const closeOverlayElm = $("#close-map-overlay");
  const regions = $("#regional-recommendation").data("info");

  // const regions = [
  //   {
  //     'code': 'US',
  //     'name': 'United States',
  //     'color': '#002549',
  //     'text': 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.'
  //   },
  //   {
  //     'code': 'UA',
  //     'name': 'Ukraine',
  //     'color': '#014F99',
  //     'text': 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.'
  //   },
  //   {
  //     'code': 'CD',
  //     'name': 'Democratic Republic of the Congo',
  //     'color': '#333399',
  //     'text': 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.'
  //   },
  //   {
  //     'code': 'AU',
  //     'name': 'Australia',
  //     'color': '#36A0E7',
  //     'text': 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.'
  //   },
  //   {
  //     'code': 'CN',
  //     'name': 'China',
  //     'color': '#84C4EF',
  //     'text': 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.'
  //   },
  // ];

  function findCode(code) {
    return $.grep(regions, function (e) {
      return e.code == code;
    });
  }

  // console.log("findCode", findCode("BR"));

  // Init the map
  theMap.vectorMap({
    map: "world_mill",
    backgroundColor: "#FFFFFF",
    panOnDrag: true,
    zoomAnimate: true,
    zoomOnScroll: false,
    focusOn: {
      x: 0.5,
      y: 0.5,
      scale: 1,
    },
    regionStyle: {
      initial: {
        fill: "#C1C7D3",
        "fill-opacity": 1,
        stroke: "none",
        "stroke-width": 0,
        "stroke-opacity": 1,
      },
    },
    onRegionClick: function (e, code) {
      console.log("onRegionClick", code);

      region = findCode(code);

      if (region.length > 0) {
        showOverlay(region);
      }
    },
    onRegionOver: function (e, code) {
      e.preventDefault();

      region = findCode(code);

      if (region.length > 0) {
        // console.log("region", region, region[0].name);

        tip.find(".country-name").html(region[0].name);

        tip.show();
        e.target.addEventListener("mousemove", mapMousemove);
      }
    },
    onRegionOut: function (e, code) {
      e.preventDefault();

      tip.hide();
      e.target.removeEventListener("mousemove", mapMousemove);
    },
    onRegionTipShow: function (e) {
      e.preventDefault();
      return false;
    },
    onViewportChange: function (e, scale) {
      // console.log('onViewportChange', e.target, 'scale', scale);
    },
  });

  // Western Sahara custom border ///////////////////////////////////////////////////////////////
  var borderPath = document.createElementNS(
    "http://www.w3.org/2000/svg",
    "path"
  );

  borderPath.setAttributeNS(null, "d", "M392.75 211.70 l6.7 0");
  borderPath.setAttributeNS(null, "stroke", "white");
  borderPath.setAttributeNS(null, "stroke-width", "0.5");
  borderPath.setAttributeNS(null, "stroke-dasharray", "0.5, 0.5");

  theMap.find("svg").find("g").first().append(borderPath);

  // India Pakistan custom border
  borderPath = document.createElementNS("http://www.w3.org/2000/svg", "path");

  borderPath.setAttributeNS(
    null,
    "d",
    "M609 201 l2 -0.5, 0.5 -1, 1.5 -0.5, 1.5 0.75, 1.5 0, 1.5 1"
  );
  borderPath.setAttributeNS(null, "stroke", "white");
  borderPath.setAttributeNS(null, "stroke-width", "0.5");
  borderPath.setAttributeNS(null, "stroke-dasharray", "0.5, 0.5");
  borderPath.setAttributeNS(null, "fill", "transparent");

  theMap.find("svg").find("g").first().append(borderPath);

  borderPath = document.createElementNS("http://www.w3.org/2000/svg", "path");

  borderPath.setAttributeNS(
    null,
    "d",
    "M607 199.75 l-2.25 -1.75, -0.75 -1.75, 0 -2.25, 1.75 -0.75, -1.5 -2, -0.75 0, 0 -1, 2 -2"
  );
  borderPath.setAttributeNS(null, "stroke", "white");
  borderPath.setAttributeNS(null, "stroke-width", "0.5");
  borderPath.setAttributeNS(null, "stroke-dasharray", "0.5, 0.5");
  borderPath.setAttributeNS(null, "fill", "transparent");

  theMap.find("svg").find("g").first().append(borderPath);

  borderPath = document.createElementNS("http://www.w3.org/2000/svg", "path");

  borderPath.setAttributeNS(null, "stroke", "#d8d8d8");
  borderPath.setAttributeNS(
    null,
    "d",
    "M607.5 199.75 l-2.0 -4.3, 1.5 -1.3, 4 0.85, 2.5 -0.5, 2 -1.75"
  );
  borderPath.setAttributeNS(null, "stroke-width", "1.0");
  borderPath.setAttributeNS(null, "stroke-dasharray", "0.5, 0.5");
  borderPath.setAttributeNS(null, "fill", "transparent");

  theMap.find("svg").find("g").first().append(borderPath);

  // Hacking map END

  // Get the map object
  var myMap = theMap.vectorMap("get", "mapObject");

  $.each(regions, function (index, region) {
    // console.log("value", region);

    if (myMap.regions[region.code] !== undefined) {
      myMap.regions[region.code].element.config.style.selected.fill =
        region.color;
      myMap.setSelectedRegions(region.code);
    }
  });

  function mapMousemove(e) {
    let top = window.pageYOffset || document.documentElement.scrollTop;
    const tip = $(".map-tooltip");

    tip.css("top", e.pageY - top + "px");
    tip.css("left", e.pageX + "px");
  }

  function showOverlay(region) {
    overlay.find(".country-name").html(region[0].name);
    overlay.find(".country-text").html(region[0].text);

    theMap.addClass("moved");
    overlay.addClass("active");
    overlay.find(".map-overlay-panel").scrollTop(0);
    closeOverlayElm.addClass("active");
  }

  closeOverlayElm.on("click", function () {
    theMap.removeClass("moved");
    overlay.removeClass("active");
    closeOverlayElm.removeClass("active");
  });
});
